import { render, staticRenderFns } from "./RsaPazientePrescrizioneBancaFarmaciComponent.vue?vue&type=template&id=9d9c48d4&scoped=true"
import script from "./RsaPazientePrescrizioneBancaFarmaciComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneBancaFarmaciComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioneBancaFarmaciComponent.vue?vue&type=style&index=0&id=9d9c48d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9c48d4",
  null
  
)

export default component.exports